module.exports = __webpack_public_path__ + "static/img/calendar_2.b08c66f0.svg";